/**
 * Model to handle roles
 */
define('dataSource/uiVersion',['jquery', 'common/config', 'lodash', 'common/utils'],
    function($, commonConfig, _, utils) {
        'use strict';

        var uiVersion = {};

        return {
            uiVersion: uiVersion,
            getUIVersion: getUIVersion
        };

        /**
         * fetches the roles into roles
         * @return {promise} promise object for fetching roles
         */
        function getUIVersion() {
            var newTimestamp = new Date().getTime(),
                versionFileUrl = utils.createURL(commonConfig.paths.uiVersion,{id: newTimestamp}),
                promise = $.get(versionFileUrl),
                deferred = $.Deferred();
            promise.done(function(response) {
                var data = parseResponse(response);
                if (data.BUILD) {
                    data.id = parseInt(data.TIMESTAMP || 0,10).toString(36);
                    _.assign(uiVersion, data);
                    _.defer(deferred.resolve, uiVersion);
                } else {
                    utils.cleanupObject(uiVersion);
                    _.defer(deferred.reject, uiVersion);
                }
            }).fail(function() {
                utils.cleanupObject(uiVersion);
                _.defer(deferred.reject, uiVersion);
            });
            return deferred.promise();
        }

        function parseResponse(response) {
            response = response || '';
            return _.reduce(response.split('\n'), function(data, line) {
                var tokens = line.split('=');
                if (tokens && _.isArray(tokens) && tokens.length >= 2) {
                    data[tokens[0].trim()] = tokens[1].trim();
                }
                return data;
            }, {});
        }
    });
